import dayjs, { type Dayjs } from 'dayjs';

// Convert UTC-anchored JS Dates to/from the local-time Dayjs values that
// MUI X DatePickers operate on, by transferring year/month/day directly
// (ignoring time-of-day) so the picker displays the same calendar date the
// JS Date represents in UTC.

export function jsDateToPickerValue(date: Date | string | null | undefined): Dayjs | null {
  if (!date) return null;
  const parsed = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(parsed.getTime())) return null;
  return dayjs()
    .year(parsed.getUTCFullYear())
    .month(parsed.getUTCMonth())
    .date(parsed.getUTCDate())
    .startOf('day');
}

export function pickerValueToJsDate(picked: Dayjs | null | undefined): Date | null {
  if (!picked) return null;
  return new Date(Date.UTC(picked.year(), picked.month(), picked.date()));
}
